import type { ReactNode } from "react";

import "./tag.css";

/**
 * What something IS, in small caps in a tinted box.
 *
 * The read-only counterpart to `Chip`: a chip is a control you press to narrow
 * a list, a tag is a fact about the row it sits on. Four screens had grown
 * their own near-copy of this — see the header of tag.css.
 *
 * `tone` names the KIND of fact, not a colour. Adding a colour here means
 * adding a token pair in src/index.css under the heading that says what that
 * family of colours is for, and then a tone that reads it.
 */
export type TagTone =
  | "verified"
  | "contested"
  | "unverified"
  | "pending"
  | "answer"
  | "neutral"
  | "quiet";

export function Tag({
  tone,
  className = "",
  children,
}: {
  tone: TagTone;
  /** For the one thing a feature may set: where the tag sits in its layout. */
  className?: string;
  children: ReactNode;
}) {
  return <span className={`tag tag--${tone}${className ? ` ${className}` : ""}`}>{children}</span>;
}
